import React from 'react';
import { Navbar } from '../components/Navbar';
import { Hero } from '../components/Hero';
import { About } from '../components/About';
import { WhyWebpagesBanner } from '../components/WhyWebpagesBanner';
import { Services } from '../components/Services';
import { Pricing } from '../components/Pricing';
import { Testimonials } from '../components/Testimonials';
import { CTA } from '../components/CTA';
import { Footer } from '../components/Footer';
export function Home() {
  return <div className="min-h-screen bg-sum-light font-sans" data-id="element-244">
      <Navbar data-id="element-245" />
      <main data-id="element-246">
        <Hero data-id="element-247" />
        <About data-id="element-248" />
        <WhyWebpagesBanner data-id="element-249" />
        <Services data-id="element-250" />
        <Pricing data-id="element-251" />
        <Testimonials data-id="element-252" />
        <CTA data-id="element-253" />
      </main>
      <Footer data-id="element-254" />
    </div>;
}